export const initialState = { loading: false, error: null };

export default (state = initialState, action) => {
    switch (action.type) {
        case 'ROUTE_CHANGE_START':
            return {
                ...initialState,
                loading: true
            };
        case 'ROUTE_CHANGE_FINISH':
            return initialState;
        case 'ROUTE_CHANGE_ERROR':
            return {
                ...initialState,
                error: action.data && action.data.error || new Error('Route change error')
            };
        default:
            return state;
    }
};
